/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import config from "../config/profileCard.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";
import { toHeaderCase } from "js-convert-case";

import { AppNavigatorService } from "../../appNavigatorService";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IProfileCardMethods extends IPluginMethodMap {
  getProfileCardProps(args: any): Promise<any>;
}

export class ProfileCardService implements IAgentPlugin {
  readonly methods: IProfileCardMethods;

  constructor() {
    this.methods = {
      getProfileCardProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        if (res?.data?.getMyProfile) {
          console.log(`profile data`, res.data);
          const _data: any = await this.getFormattedProfile(
            res.data?.getMyProfile
          );
          console.log(`formatted data`, _data);
          return {
            ...(_data || {}),
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    // return {...(config || {})}
  }

  private async getFormattedProfile(data: any) {
    let profileCard: any = {
      fullName: toHeaderCase(data?.firstName ?? "") + " " + toHeaderCase(data?.lastName?? ""),
      description: data?.bio,
      profilePicture: data?.image,
      profileCover: data?.bannerImg ?? config?.defaultCover,
      socialLinks:this.getSocialLinks(data?.socialLinks),
      firstName:data?.firstName,
      lastName:data?.lastName,
      ...(this.getDefaultSocialLinks(data.socialLinks)|| {})
    };
    return profileCard;
  }

  private getSocialLinks(socialLinks:any){
    let _socialLinks:any = [];
      if(Array.isArray(socialLinks) && socialLinks?.length <= 0){
       _socialLinks = [...config?.socialLinks];
      }
      else {
        _socialLinks=socialLinks;
      }
      return _socialLinks;
  }

  private getDefaultSocialLinks(socialLinks:any){
    let defaultWebsite = socialLinks?.find(item=>item?.name==="website")?.link ?? "#";
    let defaultFacebookLink= socialLinks?.find(item=>item?.name==="facebook")?.link ?? "#";
    let defaultTwitterLink = socialLinks?.find(item=>item?.name==="twitter")?.link ?? "#";
    let defaultInstaLink = socialLinks?.find(item=>item?.name==="instagram")?.link ?? "#";
    let defaultLinkedInLink = socialLinks?.find(item=>item?.name==="linkedin")?.link ?? "#";
    let defaultYoutubeLink = socialLinks?.find(item=>item?.name==="youtube")?.link ?? "#";
    return{
      defaultWebsite,
      defaultFacebookLink,
      defaultTwitterLink,
      defaultInstaLink,
      defaultLinkedInLink,
      defaultYoutubeLink
    }
  }

  private async isEditEnabled() {
    const srv = getWhoamiSrv();
    const user = await srv?.whoAmI();
    console.log(`user in profile service`, user);
    let formatted = true;
    if (user?.whoami === "admin") {
      formatted = false;
    }
    return formatted;
  }
}
